import moment from 'moment';
import Utils from '../../../../utils/utils';

export const formattedCount = (value) => (value ? Utils.formattingCount(value) : '0');

export const formattedPercent = (value) => `${value || 0}%`;

export const formattedDays = (value) => `${value || 0} d`;

export const formattedDate = (value) => (value ? moment(value).format('MM/DD/YYYY') : '-');

export const formattedDateTime = (value) => (value ? moment(value).format('MM/DD/YYYY HH:mm') : '-');

export const percentOf = (value, base) => {
  if (!base) return 0;

  const percent = (value / base) * 100;
  const decimals = String(percent).split('.')[1] || '';

  return percent.toFixed(decimals.length > 1 ? 2 : 1);
};

export const funnelStage = (label, value, pct, tooltip) => ({
  label,
  value: formattedCount(value),
  pct: pct ? `${pct}%` : '',
  width: Number(pct) || 0,
  tooltip,
});

export const sectionList = [
  {
    id: 'star_adherence',
    num: '01',
    nav: 'Star adherence',
    title: 'Star adherence by therapy group',
  },
  {
    id: 'gap_days',
    num: '02',
    nav: 'Gap days',
    title: 'Gap days - cumulative and fill-to-fill',
  },
  {
    id: 'short_supply',
    num: '03',
    nav: '<90/100-day supply',
    title: 'Members receiving < 90 / 100-day supplies',
  },
  {
    id: 'waiting_rx',
    num: '04',
    nav: 'Waiting for an Rx',
    title: 'Members waiting for a prescription',
  },
  {
    id: 'intake',
    num: '04a',
    nav: 'Intake & daily tracker',
    title: 'Member calls in, or comes from the daily tracker',
  },
  {
    id: 'fulfillment',
    num: '04b',
    nav: 'Processing & shipping',
    title: 'Processing and shipping times',
  },
  {
    id: 'fill_rates',
    num: '05',
    nav: '90-day fill rates',
    title: '90-day fill rates',
  },
  {
    id: 'mail_order',
    num: '06',
    nav: 'Mail order conversion',
    title: 'Mail order conversions to 90 days',
  },
  {
    id: 'interventions',
    num: '07',
    nav: 'Interventions',
    title: 'Interventions - deprescribing for POLY, ACH and COB',
  },
  {
    id: 'retention',
    num: '08',
    nav: 'Retention',
    title: 'Retention trends and rates',
  },
  {
    id: 'transfer_gaps',
    num: '09',
    nav: 'Transfer gaps',
    title: 'Exploration - gaps in adherence med transfers',
  },
  {
    id: 'pivots',
    num: '10',
    nav: 'Pivots',
    title: 'Pivots - counts by month, LOB, status, outcome and source',
  },
];

export const STAR_ADHERENCE_THRESHOLD = 80;

export const medicationTypeList = ['Brand', 'Generic', 'Immunotherapy', 'Biosimilars'];

export const pipelineLobList = ['D-SNP', 'Medi-Cal', 'Medicare', 'Commercial'];

export const pipelineStatusList = ['Identified', 'Contacted', 'In Progress', 'On Hold', 'Resolved', 'Lost'];

export const pipelineSourceList = [
  'Member Called SortPak Directly',
  'Warm Transfer',
  'Arine - Member Consent for Follow Up',
  'Other Dept - Member Consent Follow Up',
  'Mail Promotion',
  'Text Promotion',
  'Other',
];

export const pipelineFinalOutcomeList = [
  'Successful',
  'Patient No Longer Interested',
  'Unable to Transfer Rx from Other Pharmacy',
  'Unable to Follow Up',
];
